import React, { useEffect, useState } from "react";
import {
  Container,
  Risk,
  Risks,
  Images,
  Image,
  Setor,
  RiskItem,
} from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { useAuth } from "../../../hooks/AuthContext";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { MdAdd, MdDelete, MdEdit, MdSearch } from "react-icons/md";
import { AutoComplete, Button, Input, Modal, Select, Spin } from "antd";
import {
  acidentes,
  biologicos,
  ergonomicos,
  fisicos,
  quimicos,
} from "../../../services/states";
import { Message, ViewInput } from "../../../GlobalStyles";

const { confirm } = Modal;

export default function EditCompany() {
  const { user } = useAuth();
  const { company_id } = useParams();

  const [id, setId] = useState("");
  const [company, setCompany] = useState(null);
  const [companySector, setCompanySector] = useState([
    {
      name: "",
      description: "",
      companyScratchs: [],
      companyEmployees: [
        {
          name: "",
          epis: "",
          quantidade_colaboradores: 0,
          description: "",
          quantidade_colaboradores_m: 0,
          quantidade_colaboradores_f: 0,
        },
      ],
    },
  ]);

  const [name, setName] = useState("");
  const [doc, setDoc] = useState("");
  const [companyImages, setCompanyImages] = useState([[]]);
  const [loading, setLoading] = useState(true);
  const [razao_social, setRazao_social] = useState("");
  const [nome_fantasia, setNome_Fantasia] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [ramo_atividade, setRamo_atividade] = useState("");
  const [endereco, setEndereco] = useState("");
  const [cep, setCep] = useState("");
  const [nome_responsavel, setNome_responsavel] = useState("");
  const [cpf_responsavel, setCpf_responsavel] = useState("");
  const [contato_responsavel, setContato_responsavel] = useState("");
  const [message, setMessage] = useState("");
  const [observation, setObservation] = useState("");
  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleModalRisk, setVisibleModalRisk] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [id_risk, setId_risk] = useState("");
  const [id_sector, setId_sector] = useState("");
  const [name_risk, setName_risk] = useState("");
  const [type_risk, setType_risk] = useState("");
  const [description_risk, setDescription_risk] = useState("");
  const [fonte_geradora, setFonte_geradora] = useState("");
  const [perigos, setPerigos] = useState("");
  const [avaliacao_risco, setAvaliacao_risco] = useState("");
  const [epis, setEpis] = useState("");
  const [epcs, setEpcs] = useState("");
  const [risks, setRisks] = useState("");
  const [medidas_controle, setMedidas_controle] = useState("");
  const [tempo_exposicao, setTempo_exposicao] = useState("");
  const [isLoadingIA, setIsLoadingIA] = useState("");
  const [total, setTotal] = useState(0);
  const [totalM, setTotalM] = useState(0);
  const [status, setStatus] = useState("");

  useEffect(() => {
    loadingCompany();
  }, []);

  useEffect(() => {
    getFuncionarios();
  }, [companySector]);

  async function loadingCompany() {
    await api
      .get(`/company/${company_id}`)
      .then((response) => {
        const company = response.data;
        console.log(response.data);
        setCompany(company);
        setStatus(company.status);
        setId(company.id);
        if (company.status == "confirmado" || company.status == "expirado") {
          setMessage("Este formulário já foi preenchido");
        }
        if (company.razao_social) {
          setRazao_social(company.razao_social);
        }
        if (company.nome_fantasia) {
          setNome_Fantasia(company.nome_fantasia);
        }
        if (company.cnpj) {
          setCnpj(company.cnpj);
        }
        if (company.ramo_atividade) {
          setRamo_atividade(company.ramo_atividade);
        }
        if (company.observation) {
          setObservation(company.observation);
        }
        if (company.cep) {
          setCep(company.cep);
        }
        if (company.endereco) {
          setEndereco(company.endereco);
        }
        if (company.nome_responsavel) {
          setNome_responsavel(company.nome_responsavel);
        }
        if (company.cpf_responsavel) {
          setCpf_responsavel(company.cpf_responsavel);
        }
        if (company.contato_responsavel) {
          setContato_responsavel(company.contato_responsavel);
        }
        if (company.companySector.length == 0) {
          setCompanySector([
            {
              name: "",
              description: "",
              companyScratchs: [],
              companyEmployees: [
                {
                  name: "",
                  epis: "",
                  quantidade_colaboradores: 0,
                  description: "",
                  quantidade_colaboradores_m: 0,
                  quantidade_colaboradores_f: 0,
                },
              ],
            },
          ]);
        } else {
          let sectores = [...company.companySector];
          sectores.map((item) => {
            if (item.companyEmployees.length == 0) {
              item.companyEmployees = [
                {
                  name: "",
                  epis: "",
                  quantidade_colaboradores: 0,
                  description: "",
                  quantidade_colaboradores_m: 0,
                  quantidade_colaboradores_f: 0,
                },
              ];
            }
          });
          setCompanySector(sectores);
          setCompanyImages(company.companyImages);
        }
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              setMessage(response.data.message);
            } else {
              setMessage(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            setMessage("Erro Interno. verifique sua conexão e tente novamente");
          }
        } else {
          setMessage("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function verifyCompany(signature) {
    let error = "";
    companySector.map((item, index) => {
      if (!error) {
        if (!item.name || !item.description) {
          error = `Preencha o nome e descrição do setor ${index + 1}`;
        }
        item.companyEmployees.map((data, i) => {
          if (
            !data.name ||
            !data.description ||
            !data.epis ||
            !data.quantidade_colaboradores
          ) {
            error = `Preencha todos os campos da função ${i + 1} no setor ${
              index + 1
            }`;
          }
        });
      }
    });
    if (error) {
      toast.warn(error);
    } else {
      if (user) {
        if (user.id == company.collaborador_id || signature) {
          confirmCompany(false);
        } else {
          setName("");
          setDoc("");
          setVisibleModal(true);
        }
      } else {
        setName("");
        setDoc("");
        setVisibleModal(true);
      }
    }
  }

  async function getRisks(idxSector) {
    setIsLoadingIA(`S${idxSector}`);
    await api
      .get(
        `/ia/risks?sector=${companySector[idxSector].name}${
          companySector[idxSector].name
            ? `&description=${companySector[idxSector].description}`
            : ""
        }&occupations=${companySector[idxSector].companyEmployees
          .map((item) => item.name)
          .join(", ")}`,
      )
      .then((response) => {
        const companySectorEdit = [...companySector];
        companySectorEdit[idxSector].companyScratchs = response.data;
        console.log(companySectorEdit);
        setCompanySector(companySectorEdit);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.warn(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.warn("Erro Interno. verifique sua conexão e tente novamente");
          }
        } else {
          toast.warn("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingIA("");
  }

  async function getRisksImages(idxSector) {
    setIsLoadingIA(`SI${idxSector}`);
    await api
      .get(
        `/ia/risks/images?images=${companyImages[idxSector]
          .map((item) => item.photo_url)
          .join(",")}`,
      )
      .then((response) => {
        const companySectorEdit = [...companySector];
        companySectorEdit[idxSector].companyScratchs = response.data;
        console.log(companySectorEdit);
        setCompanySector(companySectorEdit);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.warn(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.warn("Erro Interno. verifique sua conexão e tente novamente");
          }
        } else {
          toast.warn("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingIA("");
  }

  async function getRisk(type, name, idxSector) {
    setIsLoadingIA(`R`);
    await api
      .get(
        `/ia/risk?name=${name}&type=${type}&sector=${companySector[idxSector].name}`,
      )
      .then((response) => {
        const risk = response.data;
        if (name_risk) {
          setDescription_risk(risk.description);
          setFonte_geradora(risk.fonte_geradora);
          setPerigos(risk.perigos);
          setAvaliacao_risco(risk.avaliacao_risco);
          setEpis(risk.epis);
          setEpcs(risk.epcs);
          setMedidas_controle(risk.medidas_controle);
          setTempo_exposicao(risk.tempo_exposicao);
        }
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.warn(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.warn("Erro Interno. verifique sua conexão e tente novamente");
          }
        } else {
          toast.warn("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingIA("");
  }

  async function getOccupation(idxSector, idxOccupation, occupation) {
    setIsLoadingIA(`S${idxSector}F${idxOccupation}`);
    if (!occupation) {
      toast.warn("Preencha a função para o autopreenchimento");
    } else {
      await api
        .get(`/ia/occupation?name=${occupation}`)
        .then((response) => {
          const companySectorEdit = [...companySector];
          companySectorEdit[idxSector].companyEmployees[
            idxOccupation
          ].description = response.data.description;
          companySectorEdit[idxSector].companyEmployees[idxOccupation].epis =
            response.data.epis;
          companySectorEdit[idxSector].companyEmployees[idxOccupation].name =
            response.data.name;
          console.log(companySectorEdit);
          setCompanySector(companySectorEdit);
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.warn(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.warn(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.warn("Erro Interno. verifique sua conexão e tente novamente");
          }
        });
    }
    setIsLoadingIA("");
  }

  async function confirmCompany(signature) {
    let userC = user;
    if (!userC) {
      userC = { id: "" };
    }
    if ((userC.id != company.collaborador_id || signature) && (!name || !doc)) {
      toast.warn("Preencha seu nome e documento para assinar o contrato");
    } else {
      await api
        .put(
          userC.id == company.collaborador_id
            ? signature
              ? `/company/${company_id}`
              : `/company-edit/${company_id}`
            : `/company/${company_id}`,
          {
            razao_social: razao_social,
            nome_fantasia: nome_fantasia,
            cnpj: cnpj,
            ramo_atividade: ramo_atividade,
            cep: cep,
            endereco: endereco,
            nome_responsavel: nome_responsavel,
            cpf_responsavel: cpf_responsavel,
            contato_responsavel: contato_responsavel,
            signature: `Assinado por ${name}, documentação: ${doc}`,
            companySector: companySector,
          },
        )
        .then(() => {
          if (userC.id == company.collaborador_id && !signature) {
            toast.success("Formulário editado com sucesso");
          } else {
            setMessage("Formulário confirmado com sucesso");
          }
          setVisibleModal(false);
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        });
    }
  }

  async function deleteFuncao(indexSetor, indexFuncao) {
    let companySectorC = [...companySector];
    let companyEmployees = [];
    if (companySectorC[indexSetor].companyEmployees[indexFuncao].id) {
      await api
        .delete(
          `/employe/${companySectorC[indexSetor].companyEmployees[indexFuncao].id}`,
        )
        .then(() => {})
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
          return "";
        });
    }
    companySectorC[indexSetor].companyEmployees.map((item, index) => {
      if (index != indexFuncao) {
        companyEmployees.push(item);
      }
    });
    companySectorC[indexSetor].companyEmployees = [...companyEmployees];
    setCompanySector(companySectorC);
    toast.success("Função excluida com sucesso");
  }

  function getFuncionarios() {
    let total = 0;
    let totalM = 0;
    companySector.map((item) => {
      item.companyEmployees.map((data) => {
        total += parseInt(data.quantidade_colaboradores) || 0;
        totalM += parseInt(data.quantidade_colaboradores_m) || 0;
      });
    });
    setTotal(total);
    setTotalM(totalM);
  }

  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <Container>
        {loading ? (
          <div
            style={{ display: "flex", width: "100%", justifyContent: "center" }}
          >
            <Spin
              size="large"
              style={{
                marginTop: 50,
              }}
            />
          </div>
        ) : (
          <>
            {message ? (
              <Message
                style={{
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {message}
              </Message>
            ) : (
              <>
                <h1>
                  {status == "alteracao" ? "Alteração" : "Cadastro"} de
                  Formulário
                </h1>
                <h2>
                  CLIQUE NO BOTÃO ABAIXO PARA TIRAR SUAS DÚVIDAS SOBRE O
                  FORMULÁRIO
                </h2>
                <Button
                  type="primary"
                  onClick={() => {
                    window.location.href =
                      "https://www.youtube.com/@focussegurancadotrabalho5442";
                  }}
                >
                  ASSISTIR VIDEO
                </Button>
                {observation && (
                  <>
                    <h2>OBSERVAÇÃO DO FRANQUEADO</h2>
                    <h4
                      style={{
                        width: "100%",
                        padding: 15,
                        background: "#f0f0f0",
                        borderRadius: 10,
                      }}
                    >
                      {observation}
                    </h4>
                  </>
                )}
                <h2>DADOS DA EMPRESA</h2>
                <div className="inputs">
                  <ViewInput style={{ maxWidth: 540 }}>
                    <p>Razão Social</p>
                    <Input
                      value={razao_social}
                      color="#888"
                      placeholder={"razão socia"}
                      onChange={(text) => {
                        setRazao_social(text.target.value);
                      }}
                    />
                  </ViewInput>
                  <ViewInput style={{ maxWidth: 540 }}>
                    <p>Nome Fantasia</p>
                    <Input
                      value={nome_fantasia}
                      color="#888"
                      placeholder={"nome fantasia"}
                      onChange={(text) => {
                        setNome_Fantasia(text.target.value);
                      }}
                    />
                  </ViewInput>
                  <ViewInput style={{ maxWidth: 370 }}>
                    <p>CNPJ/CAEPF</p>
                    <Input
                      value={cnpj}
                      color="#888"
                      placeholder={"cnpj/caepf"}
                      onChange={(text) => {
                        setCnpj(text.target.value);
                      }}
                    />
                  </ViewInput>
                  <ViewInput style={{ maxWidth: 370 }}>
                    <p>Ramo de Atividade</p>
                    <Input
                      value={ramo_atividade}
                      color="#888"
                      placeholder={"ramo de Atividade"}
                      onChange={(text) => {
                        setRamo_atividade(text.target.value);
                      }}
                    />
                  </ViewInput>
                  <ViewInput style={{ maxWidth: 300 }}>
                    <p>CEP</p>
                    <Input
                      value={cep}
                      color="#888"
                      placeholder={"cep"}
                      onChange={(text) => {
                        setCep(text.target.value);
                      }}
                    />
                  </ViewInput>
                  <ViewInput>
                    <p>Endereço</p>
                    <Input.TextArea
                      value={endereco}
                      color="#888"
                      placeholder={"endereço da empresa"}
                      onChange={(text) => {
                        setEndereco(text.target.value);
                      }}
                    />
                  </ViewInput>

                  <ViewInput style={{ maxWidth: 400 }}>
                    <p>Nome do Responsável Assinante</p>
                    <Input
                      value={nome_responsavel}
                      color="#888"
                      placeholder={"nome do responsável"}
                      onChange={(text) => {
                        setNome_responsavel(text.target.value);
                      }}
                    />
                  </ViewInput>
                  <ViewInput style={{ maxWidth: 400 }}>
                    <p>CPF do Responsável</p>
                    <Input
                      value={cpf_responsavel}
                      color="#888"
                      placeholder={"cpf do responsável"}
                      onChange={(text) => {
                        setCpf_responsavel(text.target.value);
                      }}
                    />
                  </ViewInput>
                  <ViewInput style={{ maxWidth: 240 }}>
                    <p>Contato do Responsável</p>
                    <Input
                      value={contato_responsavel}
                      color="#888"
                      placeholder={"telefone"}
                      onChange={(text) => {
                        setContato_responsavel(text.target.value);
                      }}
                    />
                  </ViewInput>
                </div>

                <h2>QUADRO DE LEVANTAMENTO DE RISCOS OCUPACIONAIS </h2>
                <div className="inputs">
                  {companySector.map((item, index) => {
                    return (
                      <Setor
                        key={index}
                        style={{
                          borderBottomWidth:
                            index + 1 == companySector.length ? 0 : 2,
                        }}
                      >
                        <h3>Setor {index + 1}</h3>

                        <ViewInput style={{ maxWidth: "540px" }}>
                          <p>Setor</p>
                          <Input
                            value={item.name}
                            color="#888"
                            placeholder={"setor"}
                            onChange={(text) => {
                              let companySectorC = [...companySector];
                              companySectorC[index].name = text.target.value;
                              setCompanySector(companySectorC);
                            }}
                          />
                        </ViewInput>
                        <ViewInput style={{ maxWidth: "540px" }}>
                          <p>Descrição do Setor</p>
                          <Input.TextArea
                            value={item.description}
                            color="#888"
                            placeholder={"descrição"}
                            onChange={(text) => {
                              let companySectorC = [...companySector];
                              companySectorC[index].description =
                                text.target.value;
                              setCompanySector(companySectorC);
                            }}
                          />
                        </ViewInput>

                        <h2>IMAGENS DO SETOR (máx 5)</h2>
                        <Images>
                          {companyImages[index].length <= 4 && (
                            <Image style={{ position: "relative" }}>
                              <Button
                                type="primary"
                                style={{
                                  display: "flex",
                                  margin: "auto",
                                  borderRadius: 6,
                                }}
                              >
                                <MdAdd color="#fff" size={24} />
                                Nova Imagem
                              </Button>
                              <input
                                id="avatar"
                                style={{
                                  cursor: "pointer",
                                  position: "absolute",
                                  width: "100%",
                                  height: "100%",
                                  opacity: 0,
                                }}
                                multiple={false}
                                type="file"
                                accept="image/"
                                onChange={async (file) => {
                                  let [filesUp] = Object.values(
                                    file.target.files,
                                  );
                                  const data = new FormData();
                                  data.append("index", index);
                                  data.append("file", filesUp, filesUp.name);
                                  await api
                                    .post(`/company-image/${id}`, data)
                                    .then(async (response) => {
                                      let companyImagesC = [...companyImages];
                                      companyImagesC[index].push(response.data);
                                      setCompanyImages(companyImagesC);
                                      toast.success(
                                        `Imagem foi enviada com sucesso`,
                                      );
                                    })
                                    .catch(({ response }) => {
                                      if (response) {
                                        if (response.data) {
                                          if (response.data.message) {
                                            toast.warn(response.data.message);
                                          } else {
                                            toast.error(
                                              "Erro Interno. verifique sua conexão e tente novamente",
                                            );
                                          }
                                        } else {
                                          toast.error(
                                            "Erro Interno. verifique sua conexão e tente novamente",
                                          );
                                        }
                                      } else {
                                        toast.error(
                                          "Erro Interno. verifique sua conexão e tente novamente",
                                        );
                                      }
                                    });
                                }}
                              />
                            </Image>
                          )}
                          {companyImages[index].map((item) => {
                            return (
                              <Image>
                                <img src={item.photo_url} />
                                <Button
                                  className="delete-button"
                                  onClick={async () => {
                                    await api
                                      .delete(`/company-image/${item.id}`)
                                      .then(async () => {
                                        let companyImagesC = [...companyImages];
                                        companyImagesC[index] = companyImagesC[
                                          index
                                        ].filter((data) => {
                                          return item.id != data.id;
                                        });
                                        setCompanyImages(companyImagesC);
                                        toast.success(
                                          `Imagem foi deletada com sucesso`,
                                        );
                                      })
                                      .catch(({ response }) => {
                                        if (response) {
                                          if (response.data) {
                                            if (response.data.message) {
                                              toast.warn(response.data.message);
                                            } else {
                                              toast.error(
                                                "Erro Interno. verifique sua conexão e tente novamente",
                                              );
                                            }
                                          } else {
                                            toast.error(
                                              "Erro Interno. verifique sua conexão e tente novamente",
                                            );
                                          }
                                        } else {
                                          toast.error(
                                            "Erro Interno. verifique sua conexão e tente novamente",
                                          );
                                        }
                                      });
                                  }}
                                  style={{
                                    width: 30,
                                    height: 30,
                                    marginBottom: 10,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginTop: 10,
                                    padding: 0,
                                    borderRadius: 6,
                                  }}
                                >
                                  <MdDelete color="#fff" size={20} />
                                </Button>
                              </Image>
                            );
                          })}
                        </Images>
                        <h2>FUNÇÕES DO SETOR</h2>
                        {item.companyEmployees.map((data, i) => {
                          return (
                            <>
                              <h3
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: 10,
                                  width: "100%",
                                }}
                              >
                                Função {i + 1}
                                {!!i && (
                                  <Button
                                    type="primary"
                                    className="delete-button"
                                    onClick={() => {
                                      confirm({
                                        okText: "Confirmar",
                                        title: "Deseja excluir essa função?",
                                        icon: <ExclamationCircleFilled />,
                                        content: `Após essa ação, a função ${
                                          i + 1
                                        } será excluida.`,
                                        onOk() {
                                          deleteFuncao(index, i);
                                        },
                                        onCancel() {},
                                        cancelText: "Cancelar",
                                      });
                                    }}
                                    style={{
                                      width: 28,
                                      height: 28,
                                      marginLeft: 8,
                                      borderRadius: 6,
                                      padding: 0,
                                    }}
                                  >
                                    <MdDelete color="#fff" size={18} />
                                  </Button>
                                )}
                              </h3>
                              <ViewInput style={{ maxWidth: "500px" }}>
                                <p>Função</p>
                                <Input.Search
                                  type="primary"
                                  enterButton
                                  loading={isLoadingIA == `S${index}F${i}`}
                                  disabled={
                                    isLoadingIA &&
                                    isLoadingIA != `S${index}F${i}`
                                  }
                                  value={data.name}
                                  color="#888"
                                  onSearch={() => {
                                    getOccupation(index, i, data.name);
                                  }}
                                  placeholder={"funcao"}
                                  onChange={(text) => {
                                    let companySectorC = [...companySector];
                                    companySectorC[index].companyEmployees[
                                      i
                                    ].name = text.target.value;
                                    setCompanySector(companySectorC);
                                  }}
                                />
                              </ViewInput>
                              <ViewInput style={{ maxWidth: "245px" }}>
                                <p>Colaboradores</p>
                                <Input
                                  prefix="QTD"
                                  type="number"
                                  value={data.quantidade_colaboradores}
                                  color="#888"
                                  placeholder={"0"}
                                  onChange={(text) => {
                                    let companySectorC = [...companySector];
                                    if (parseInt(text.target.value) > 0) {
                                      companySectorC[index].companyEmployees[
                                        i
                                      ].quantidade_colaboradores =
                                        parseInt(text.target.value) || "";
                                      companySectorC[index].companyEmployees[
                                        i
                                      ].quantidade_colaboradores_f =
                                        parseInt(text.target.value) || "";
                                      companySectorC[index].companyEmployees[
                                        i
                                      ].quantidade_colaboradores_m = "";
                                    } else {
                                      companySectorC[index].companyEmployees[
                                        i
                                      ].quantidade_colaboradores = "";
                                      companySectorC[index].companyEmployees[
                                        i
                                      ].quantidade_colaboradores_f = "";
                                      companySectorC[index].companyEmployees[
                                        i
                                      ].quantidade_colaboradores_m = "";
                                    }
                                    setCompanySector(companySectorC);
                                  }}
                                />
                              </ViewInput>
                              <ViewInput style={{ maxWidth: "150px" }}>
                                <p>Masculino</p>
                                <Input
                                  prefix="QTD"
                                  type="number"
                                  value={data.quantidade_colaboradores_m}
                                  color="#888"
                                  placeholder={"0"}
                                  onChange={(text) => {
                                    let companySectorC = [...companySector];
                                    if (
                                      parseInt(text.target.value) >
                                      (parseInt(
                                        companySectorC[index].companyEmployees[
                                          i
                                        ].quantidade_colaboradores,
                                      ) || 0)
                                    ) {
                                      toast.warn(
                                        "Número de colaboradores masculinos é maior que o total de colaboradores",
                                      );
                                    } else {
                                      companySectorC[index].companyEmployees[
                                        i
                                      ].quantidade_colaboradores_m = text.target
                                        .value
                                        ? parseInt(text.target.value)
                                        : "";
                                      companySectorC[index].companyEmployees[
                                        i
                                      ].quantidade_colaboradores_f = text.target
                                        .value
                                        ? companySectorC[index]
                                            .companyEmployees[i]
                                            .quantidade_colaboradores -
                                          parseInt(text.target.value)
                                        : companySectorC[index]
                                            .companyEmployees[i]
                                            .quantidade_colaboradores;
                                      setCompanySector(companySectorC);
                                    }
                                  }}
                                />
                              </ViewInput>
                              <ViewInput style={{ maxWidth: "150px" }}>
                                <p>Feminino</p>
                                <Input
                                  prefix="QTD"
                                  value={data.quantidade_colaboradores_f || 0}
                                  color="#888"
                                  disabled
                                />
                              </ViewInput>

                              <ViewInput style={{ maxWidth: "553px" }}>
                                <p>Descrição das Atividades</p>
                                <Input.TextArea
                                  value={data.description}
                                  color="#888"
                                  placeholder={"descrição"}
                                  onChange={(text) => {
                                    let companySectorC = [...companySector];
                                    companySectorC[index].companyEmployees[
                                      i
                                    ].description = text.target.value;
                                    setCompanySector(companySectorC);
                                  }}
                                />
                              </ViewInput>

                              <ViewInput
                                style={{ maxWidth: "528px", marginBottom: 20 }}
                              >
                                <p>EPIS usados na função</p>
                                <Input.TextArea
                                  value={data.epis}
                                  color="#888"
                                  placeholder={"epis"}
                                  onChange={(text) => {
                                    let companySectorC = [...companySector];
                                    companySectorC[index].companyEmployees[
                                      i
                                    ].epis = text.target.value;
                                    setCompanySector(companySectorC);
                                  }}
                                />
                              </ViewInput>
                              {item.companyEmployees.length != i + 1 && <hr />}
                            </>
                          );
                        })}
                        <Button
                          type="primary"
                          onClick={() => {
                            let companySectorC = [...companySector];
                            let companyImagesC = [...companyImages];
                            companyImagesC.push([]);
                            companySectorC[index].companyEmployees.push({
                              name: "",
                              id: "",
                              epis: "",
                              quantidade_colaboradores: 0,
                              description: "",
                              quantidade_colaboradores_m: 0,
                              quantidade_colaboradores_f: 0,
                            });
                            setCompanyImages(companyImagesC);
                            setCompanySector(companySectorC);
                          }}
                          style={{
                            marginTop: 15,
                            marginBottom: 15,
                            display: "flex",
                          }}
                        >
                          <MdAdd color="#fff" size={24} />
                          Nova Função
                        </Button>
                        <h2>RISCOS DO SETOR</h2>
                        <div style={{ display: "flex" }}>
                          <Button
                            type="primary"
                            onClick={() => {
                              setVisibleModalRisk(true);
                              setId_risk(-1);
                              setId_sector(index);
                              setName_risk("");
                              setDescription_risk("");
                              setType_risk("");
                              setEpcs("");
                              setEpis("");
                              setTempo_exposicao("");
                              setMedidas_controle("");
                              setPerigos("");
                              setAvaliacao_risco("");
                              setFonte_geradora("");
                            }}
                            style={{
                              marginTop: 15,
                              marginBottom: 15,
                              display: "flex",
                              marginRight: 15,
                            }}
                          >
                            <MdAdd color="#fff" size={24} />
                            Novo Risco
                          </Button>

                          <Button
                            type="primary"
                            loading={isLoadingIA == `S${index}`}
                            disabled={isLoadingIA && isLoadingIA != `S${index}`}
                            onClick={() => {
                              getRisks(index);
                            }}
                            style={{
                              marginTop: 15,
                              marginBottom: 15,
                              display: "flex",
                              marginRight: 15,
                            }}
                          >
                            <MdSearch color="#fff" size={24} />
                            Buscar Riscos
                          </Button>
                          <Button
                            type="primary"
                            loading={isLoadingIA == `SI${index}`}
                            disabled={
                              isLoadingIA && isLoadingIA != `SI${index}`
                            }
                            onClick={() => {
                              getRisksImages(index);
                            }}
                            style={{
                              marginTop: 15,
                              marginBottom: 15,
                              display: "flex",
                            }}
                          >
                            <MdSearch color="#fff" size={24} />
                            Buscar Riscos pelas Images
                          </Button>
                        </div>
                        <Risks>
                          {!item.companyScratchs?.length && (
                            <Message>
                              Nenhum risco cadastrado até o momento
                            </Message>
                          )}
                          {item.companyScratchs.map((risk, riskIndex) => {
                            return (
                              <RiskItem key={riskIndex}>
                                <div className="risk-info">
                                  <p>
                                    <strong>
                                      Risco {risk.type} - {risk.name}
                                    </strong>
                                  </p>
                                  <p>
                                    <strong>Descrição:</strong>{" "}
                                    {risk.description}
                                  </p>
                                  {risk.fonte_geradora && (
                                    <p>
                                      <strong>Fonte Geradora:</strong>{" "}
                                      {risk.fonte_geradora}
                                    </p>
                                  )}
                                  {risk.perigos && (
                                    <p>
                                      <strong>Perigos:</strong> {risk.perigos}
                                    </p>
                                  )}
                                  {risk.avaliacao_risco && (
                                    <p>
                                      <strong>Avaliação de Risco:</strong>{" "}
                                      {risk.avaliacao_risco}
                                    </p>
                                  )}
                                  {risk.epis && (
                                    <p>
                                      <strong>EPIs:</strong> {risk.epis}
                                    </p>
                                  )}
                                  {risk.epcs && (
                                    <p>
                                      <strong>EPCs:</strong> {risk.epcs}
                                    </p>
                                  )}
                                  {risk.medidas_controle && (
                                    <p>
                                      <strong>Medidas de Controle:</strong>{" "}
                                      {risk.medidas_controle}
                                    </p>
                                  )}
                                  {risk.tempo_exposicao && (
                                    <p>
                                      <strong>Tempo de Exposição:</strong>{" "}
                                      {risk.tempo_exposicao}
                                    </p>
                                  )}
                                </div>
                                <div className="risk-actions">
                                  <Button
                                    type="primary"
                                    onClick={() => {
                                      setId_sector(index);
                                      setId_risk(riskIndex);
                                      setName_risk(risk.name);
                                      setDescription_risk(risk.description);
                                      setType_risk(risk.type);
                                      setEpcs(risk.epcs);
                                      setEpis(risk.epis);
                                      setMedidas_controle(
                                        risk.medidas_controle,
                                      );
                                      setTempo_exposicao(risk.tempo_exposicao);
                                      setPerigos(risk.perigos);
                                      setAvaliacao_risco(risk.avaliacao_risco);
                                      setFonte_geradora(risk.fonte_geradora);
                                      setVisibleModalRisk(true);
                                    }}
                                  >
                                    <MdEdit />
                                    Editar
                                  </Button>
                                  <Button
                                    className="delete-button"
                                    onClick={() => {
                                      confirm({
                                        okText: "Confirmar",
                                        title: "Deseja excluir esse risco?",
                                        icon: <ExclamationCircleFilled />,
                                        content: `Após essa ação, a o risco ${risk.type} - ${risk.name} será excluido.`,
                                        onOk() {
                                          let companySectorC = [
                                            ...companySector,
                                          ];
                                          companySectorC[
                                            index
                                          ].companyScratchs = companySectorC[
                                            index
                                          ].companyScratchs.filter(
                                            (item, idx) => idx != riskIndex,
                                          );
                                          setCompanySector(companySectorC);
                                        },
                                        onCancel() {},
                                        cancelText: "Cancelar",
                                      });
                                    }}
                                  >
                                    <MdDelete />
                                    Excluir
                                  </Button>
                                </div>
                              </RiskItem>
                            );
                          })}
                        </Risks>
                      </Setor>
                    );
                  })}
                </div>
                <h2
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: 15,
                    width: "100%",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    type="primary"
                    onClick={() => {
                      let companySectorC = [...companySector];
                      let companyImagesC = [...companyImages];
                      companySectorC.push({
                        name: "",
                        description: "",
                        companyScratchs: [],
                        companyEmployees: [
                          {
                            name: "",
                            id: "",
                            epis: "",
                            quantidade_colaboradores: 0,
                            description: "",
                            quantidade_colaboradores_m: 0,
                            quantidade_colaboradores_f: 0,
                          },
                        ],
                      });
                      companyImagesC.push([]);
                      setCompanyImages(companyImagesC);
                      setCompanySector(companySectorC);
                    }}
                  >
                    <MdAdd color="#fff" size={24} />
                    Novo Setor
                  </Button>
                </h2>

                <h4>Total de Funcionários: {total}</h4>
                <h4>Total de Funcionários Femininos: {total - totalM || 0}</h4>
                <h4>Total de Funcionários Masculinos: {totalM}</h4>

                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    margin: "35px 0",
                  }}
                >
                  {user && user.id == company.collaborador_id && (
                    <Button
                      type="primary"
                      title={"Salvar"}
                      style={{
                        margin: "0 10px",
                        height: 45,
                        fontSize: 18,
                        width: "100%",
                        maxWidth: 350,
                      }}
                      onClick={() => {
                        verifyCompany(false);
                      }}
                    >
                      Salvar
                    </Button>
                  )}
                  <Button
                    type="primary"
                    title={"Salvar e Assinar"}
                    style={{
                      margin: "0 10px",
                      height: 45,
                      fontSize: 18,
                      width: "100%",
                      maxWidth: 350,
                    }}
                    onClick={() => {
                      if (user && user.id == company.collaborador_id) {
                        setName("");
                        setDoc("");
                        setVisibleModal(true);
                      } else {
                        verifyCompany(false);
                      }
                    }}
                  >
                    Salvar e Assinar
                  </Button>
                </div>
              </>
            )}
          </>
        )}
        <Modal
          title={"Validar Formulário"}
          width={500}
          confirmLoading={isLoadingModal}
          open={visibleModal}
          okText={"Validar Formulário"}
          okButtonProps={{
            style: {
              background: name && doc ? "#25b03a" : "#25b03a98",
            },
          }}
          cancelText="FECHAR"
          onOk={() => {
            if (name && doc) {
              confirmCompany(true);
            } else {
              toast.warn("Preencha nome e cpf para validar formulário");
            }
          }}
          onCancel={() => {
            setVisibleModal(false);
          }}
        >
          <div
            style={{
              paddingTop: 0,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <p
              style={{
                width: "90%",
                fontSize: 15,
                margin: "15px 0",
                textAlign: "center",
                color: "#000",
              }}
            >
              Digite seu Nome e CPF para validar o formulário
            </p>

            <ViewInput>
              <p>Nome do Responsável</p>
              <Input
                placeholder="nome completo"
                value={name}
                onChange={(text) => {
                  setName(text.target.value);
                }}
              />
            </ViewInput>
            <ViewInput>
              <p>CPF do Responsável</p>
              <Input
                placeholder="cpf"
                value={doc}
                onChange={(text) => {
                  setDoc(text.target.value);
                }}
              />
            </ViewInput>
          </div>
        </Modal>

        <Modal
          title={id_risk != -1 ? "Editar Risco" : "Cadastrar Risco"}
          width={500}
          confirmLoading={isLoadingModal}
          open={visibleModalRisk}
          okText={"SALVAR"}
          cancelText="FECHAR"
          onOk={() => {
            let companySectorC = [...companySector];
            const saveRisk = {
              name: name_risk,
              type: type_risk,
              description: description_risk,
              fonte_geradora: fonte_geradora,
              perigos: perigos,
              avaliacao_risco: avaliacao_risco,
              epis: epis,
              epcs: epcs,
              medidas_controle: medidas_controle,
              tempo_exposicao: tempo_exposicao,
            };
            if (id_risk != -1) {
              companySectorC[id_sector].companyScratchs[id_risk] = saveRisk;
            } else {
              companySectorC[id_sector].companyScratchs.push(saveRisk);
            }
            setCompanySector(companySectorC);
            setVisibleModalRisk(false);
          }}
          onCancel={() => {
            if (isLoadingIA == `R`) {
              toast.warn("Aguarde a finalização da busca para fechar modal");
            } else {
              setVisibleModalRisk(false);
            }
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <ViewInput>
              <p>Tipo*</p>
              <Select
                placeholder="selecionar tipo do risco"
                value={type_risk || null}
                disabled={isLoadingIA == `R`}
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setType_risk(value);

                  switch (value) {
                    case "Fisico": {
                      setRisks(
                        fisicos.map((item) => {
                          return {
                            label: item,
                            value: item,
                          };
                        }),
                      );
                      break;
                    }
                    case "Quimico": {
                      setRisks(
                        quimicos.map((item) => {
                          return {
                            label: item,
                            value: item,
                          };
                        }),
                      );
                      break;
                    }
                    case "Acidente": {
                      setRisks(
                        acidentes.map((item) => {
                          return {
                            label: item,
                            value: item,
                          };
                        }),
                      );
                      break;
                    }
                    case "Ergonomico": {
                      setRisks(
                        ergonomicos.map((item) => {
                          return {
                            label: item,
                            value: item,
                          };
                        }),
                      );
                      break;
                    }
                    case "Biologico": {
                      setRisks(
                        biologicos.map((item) => {
                          return {
                            label: item,
                            value: item,
                          };
                        }),
                      );
                      break;
                    }
                  }
                }}
              >
                <Select.Option value="Fisico">Fisico</Select.Option>
                <Select.Option value="Quimico">Quimico</Select.Option>
                <Select.Option value="Acidente">Acidente</Select.Option>
                <Select.Option value="Ergonomico">Ergonomico</Select.Option>
                <Select.Option value="Biologico">Biologico</Select.Option>
              </Select>
            </ViewInput>
            <ViewInput>
              <p>Nome*</p>
              <AutoComplete
                disabled={!type_risk}
                options={risks}
                style={{ width: "100%", textAlign: "left" }}
                placeholder="nome do risco"
                value={name_risk}
                onChange={(value) => setName_risk(value)}
              >
                <Input.Search
                  enterButton
                  onSearch={() => {
                    getRisk(type_risk, name_risk, id_sector);
                  }}
                  loading={isLoadingIA == `R`}
                  disabled={isLoadingIA && isLoadingIA != `R`}
                />
              </AutoComplete>
            </ViewInput>
            <ViewInput>
              <p>Descrição*</p>
              <Input.TextArea
                style={{ minHeight: 40 }}
                placeholder="descreva o risco"
                value={description_risk}
                onChange={(event) => setDescription_risk(event.target.value)}
              />
            </ViewInput>
            <ViewInput>
              <p>Fonte Geradora</p>
              <Input.TextArea
                style={{ minHeight: 40 }}
                placeholder="fonte geradora"
                value={fonte_geradora}
                onChange={(event) => setFonte_geradora(event.target.value)}
              />
            </ViewInput>
            <ViewInput>
              <p>Perigos (Atividade e Processo)</p>
              <Input.TextArea
                style={{ minHeight: 40 }}
                placeholder="perigos"
                value={perigos}
                onChange={(event) => setPerigos(event.target.value)}
              />
            </ViewInput>
            <ViewInput>
              <p>Avaliação do Risco</p>
              <Input
                placeholder="avaliação do risco"
                value={avaliacao_risco}
                onChange={(event) => setAvaliacao_risco(event.target.value)}
              />
            </ViewInput>
            <ViewInput>
              <p>EPI(s) Recomendado(s) </p>
              <Input.TextArea
                style={{ minHeight: 40 }}
                placeholder="epis"
                value={epis}
                onChange={(event) => setEpis(event.target.value)}
              />
            </ViewInput>
            <ViewInput>
              <p>EPC(s) Recomendado(s) </p>
              <Input.TextArea
                style={{ minHeight: 40 }}
                placeholder="epcs"
                value={epcs}
                onChange={(event) => setEpcs(event.target.value)}
              />
            </ViewInput>
            <ViewInput>
              <p>Medidas de Controle Adicional</p>
              <Input.TextArea
                style={{ minHeight: 20 }}
                placeholder="medidas de controle"
                value={medidas_controle}
                onChange={(event) => setMedidas_controle(event.target.value)}
              />
            </ViewInput>
            <ViewInput>
              <p>Tempo de Exposição</p>
              <Input.TextArea
                style={{ minHeight: 20 }}
                placeholder="tempo de exposição ao risco"
                value={tempo_exposicao}
                onChange={(event) => setTempo_exposicao(event.target.value)}
              />
            </ViewInput>
          </div>
        </Modal>
      </Container>
    </div>
  );
}
